require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-content-type-sandbox.json") })
        }
      }, "path---es-content-type-sandbox");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-content-type-sandbox!./.cache/json/es-content-type-sandbox.json
// module id = 2541
// module chunks = 231608221292675